export default __webpack_public_path__ + "static/media/repeat_visitor.10c73602.png";